export const ERROR_MESSAGES: Record<string, string> = {
  SCORE_VALIDATION_FAILURE: 'We had trouble scoring your answer. Please try again.',
  JSON_PARSE_FAILURE: 'Something went wrong analyzing your response. Please try again.',
  API_TIMEOUT: 'Our AI is taking longer than usual. Please try again in a moment.',
  RATE_LIMIT: "We're experiencing high demand. Please try again in a few seconds.",
  SESSION_LIMIT_REACHED:
    "You've used all your free sessions this month. Upgrade to Pro for unlimited practice.",
  DRILL_LIMIT_REACHED: "You've done a lot of drilling today — nice work. Try again tomorrow.",
  REQUEST_RATE_LIMITED: "You're sending requests a little too fast. Wait a moment and try again.",
  STORY_CAP_REACHED:
    "You've reached the Story Bank limit for free accounts. Upgrade to Pro to save more.",
  MINER_SESSION_LIMIT_REACHED:
    "You've used this week's story-building conversations. They reset on a rolling 7-day window.",
  MINER_TURN_LIMIT_REACHED:
    "That's the end of this conversation's questions. You can still turn what you've shared into a story.",
  MINER_EXTRACT_LIMIT_REACHED:
    "You've drafted as many stories as this conversation allows. Start a new conversation to build more.",
  PAYMENT_FAILED: "Your payment didn't go through. Update your card to continue with Pro.",
  UNAUTHORIZED: 'Please sign in to continue.',
  FORBIDDEN: "You don't have permission to access this.",
  NOT_FOUND: "We couldn't find what you were looking for.",
  MODEL_ERROR: 'We had trouble scoring your answer. Please try again.',
  INTERNAL_ERROR: 'Something went wrong on our end. Please try again.',
}

/**
 * VALIDATION_ERROR is deliberately absent from ERROR_MESSAGES: the Edge Functions
 * send a specific, user-actionable message with it (which field, which limit), and
 * a generic mapping here would throw that away. `serverMessage` covers it.
 */
export function getErrorMessage(code: string, serverMessage?: string | null): string {
  const mapped = ERROR_MESSAGES[code]
  if (mapped) return mapped
  if (serverMessage?.trim()) return serverMessage.trim()
  return ERROR_MESSAGES.INTERNAL_ERROR as string
}
